<mat-card>
  <mat-card-header *ngIf="title">
    <ng-container *ngIf="tooltipText">
      <h3 [matTooltip]="tooltipText" class="title">{{ title }} <mat-icon>info</mat-icon></h3>
    </ng-container>
    <ng-container *ngIf="!tooltipText">
      <h3 class="title">{{ title }}</h3>
    </ng-container>
  </mat-card-header>
  <mat-card-content>
    <div class="flex flex-col">
      <ng-content></ng-content>
    </div>
  </mat-card-content>
</mat-card>
